import React from 'react';
import { Box, Button, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import CloseIcon from '@mui/icons-material/Close';
import {
  SMS_BUNDLE_BASE_PLAN_ID,
  SMS_BUNDLE_DESTINATION_NUMBER,
  SMS_DESTINATION_NUMBER,
} from '@src/constants/mobifone';
import WarningIcon from '@src/assets/icons/warning-orange.svg';
import { redirectToSMSApp } from '@src/services/sms';

import { StyledPaymentSMSDialog } from './index.style';

const SMSCancelDialog = ({ selectedOrder, openDialog, setOpenDialog }) => {
  const { t } = useTranslation();

  const { user } = useSelector((state) => state.auth);

  const handleClose = () => {
    setOpenDialog(false);
  };

  const renderSMSDestination = () => {
    if (
      SMS_BUNDLE_BASE_PLAN_ID.includes(
        selectedOrder?.package?.paymentHub?.basePlanId,
      )
    ) {
      return SMS_BUNDLE_DESTINATION_NUMBER;
    }
    return SMS_DESTINATION_NUMBER;
  };

  return (
    <StyledPaymentSMSDialog open={openDialog} onClose={handleClose}>
      <div className="wrapper">
        <Box className="header">
          <Typography className="title">{t('cancelPackage')}</Typography>
          <Box onClick={handleClose}>
            <CloseIcon className="close-icon" />
          </Box>
        </Box>

        <Box className="payment-info">{t('introCancelSMS')}:</Box>
        <Box className="payment-syntax-container">
          <Box className="payment-syntax-title">{t('smsGuide')}</Box>
          <Box className="payment-syntax-content">
            HUY {selectedOrder?.package?.paymentHub?.basePlanId}{' '}
            <span className="send-text">{t('lowercaseSend')}</span>{' '}
            {renderSMSDestination()}
          </Box>
        </Box>
        <Box className="payment-note">({t('syntaxSMSNote')})</Box>
        <Box className="payment-warning">
          <img className="img-icon-warning" src={WarningIcon} alt="warning" />
          <Box>
            {t('smsWarn')} {user?.phoneNumber || user?.firstName || ''}{' '}
            {t('toRecorded')}
          </Box>
        </Box>
        <Box className="mobile-sms">
          {redirectToSMSApp({
            body: `HUY ${selectedOrder?.package?.paymentHub?.basePlanId}`,
            target: renderSMSDestination(),
            content: (
              <Button onClick={handleClose} className="button-sms">
                {t('composeSMS')}
              </Button>
            ),
          })}
        </Box>
      </div>
    </StyledPaymentSMSDialog>
  );
};

export default SMSCancelDialog;
